import React from 'react';
import { Check } from 'lucide-react';

interface MetroProgressProps {
  steps: string[];
  currentStep: number;
  compact?: boolean;
}

export function MetroProgress({ steps, currentStep, compact = false }: MetroProgressProps) {
  return (
    <div className={`w-full ${compact ? 'py-3' : 'py-4'} bg-background border-b`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center space-x-2 md:space-x-4">
          {steps.map((step, index) => {
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;
            const isLast = index === steps.length - 1;

            return (
              <React.Fragment key={step}>
                <div className="flex flex-col items-center">
                  <div
                    className={`
                      w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all
                      ${isCompleted 
                        ? 'bg-green-500 text-white' 
                        : isActive 
                          ? 'bg-primary text-white' 
                          : 'bg-gray-200 text-gray-600'
                      }
                    `}
                  >
                    {isCompleted ? (
                      <Check className="w-4 h-4" />
                    ) : (
                      index + 1
                    )}
                  </div>
                  {!compact && (
                    <span className={`mt-1 text-xs font-medium ${
                      isActive ? 'text-primary' : 'text-muted-foreground'
                    }`}>
                      {step}
                    </span>
                  )}
                </div>
                {!isLast && (
                  <div className={`flex-1 h-0.5 mx-2 ${
                    isCompleted ? 'bg-green-500' : 'bg-gray-200'
                  }`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}